import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp';
import serviceIconApps from '../../assets/images/service-icon-apps.webp';
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp';
import serviceIconWebsite from '../../assets/images/service-icon-website.webp';
import ServicesPricingCTA from '../ServicesPricingCTA';

const serviceLinks = [
  {
    label: 'Web Development in Northwest Arkansas',
    icon: serviceIconWebsite,
    path: '/services/websites',
  },
  {
    label: 'Mobile App Development in Northwest Arkansas',
    icon: serviceIconApps,
    path: '/services/appdev',
  },
  {
    label: 'Cloud Consulting in Northwest Arkansas',
    icon: serviceIconConsulting,
    path: '/services/consulting',
  },
  {
    label: '3D Printing in Northwest Arkansas',
    icon: serviceIcon3dPrint,
    path: '/services/3dprints',
  },
];

const Services: React.FC = () => {
  return (
    <div className="services-container">
      <section className="services-intro">
        <h1>Technology Services for Northwest Arkansas</h1>
        <p>
          Hogcloud provides affordable website development and hosting, custom
          mobile apps, experienced cloud development, AI agents and prompting,
          and custom 3D printing for Northwest Arkansas small businesses,
          creators, families, and local organizations.
        </p>
        <nav className="local-service-links" aria-label="Northwest Arkansas service pages">
          {serviceLinks.map((serviceLink) => (
            <Link key={serviceLink.path} to={serviceLink.path} aria-label={serviceLink.label}>
              <img src={serviceLink.icon} alt="" aria-hidden="true" />
            </Link>
          ))}
        </nav>
      </section>

      <ServicesPricingCTA />

    </div>
  );
};

export default Services;
